<mat-accordion>
  <mat-expansion-panel [expanded]="searchList.length > 0 && displayList" disabled hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title class="list-title m-auto" *ngIf="searchList.length > 0">Rate Search Inquiry List</mat-panel-title>
      <mat-panel-description>
        <div class="container-fluid">
          <div class="row">
            <div *ngIf="searchList.length === maxQueries" class="col d-flex align-items-center">
              <span class="d-inline-block text-truncate">Maximum of {{ maxQueries }} inquiries reached.</span>
            </div>
            <div class="col d-flex justify-content-end">
              <button (click)="clearList()" aria-label="Clear List" class="my-3 mr-2 font-weight-bold border-danger-dark" color="warn"
                      mat-stroked-button
                      [hidden]="searchList.length === 0">
                Clear List
              </button>
              <button (click)="displayList = (searchList.length > 0) ? !displayList : false" aria-label="Show/Hide Requests"
                      class="my-3 mr-2 list-search"
                      color="accent" mat-flat-button [hidden]="searchList.length === 0">
                {{ displayList ? 'Hide ' : 'Show ' }} {{ searchList.length }} Requests
              </button>
              <mat-spinner *ngIf="loading" class="mt-3" diameter="38" color="accent"></mat-spinner>
              <button *ngIf="!loading" (click)="searchInquiry()" [hidden]="searchList.length === 0" aria-label="Search" class="my-3 mr-2 list-search"
                      color="accent" mat-flat-button>
                Search
              </button>
            </div>
          </div>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-list *ngIf="searchList.length > 0">
      <mat-divider></mat-divider>
      <mat-list-item>
        <div class="container-fluid" matLine>
          <div class="row row-cols-sm-12 p-2">
            <div class="col-md-2 col-sm-2" *ngFor="let header of headerList">
              <div class="list-column">{{ header }}</div>
            </div>
          </div>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item *ngFor="let data of searchList; let lastItem = last; let i = index">
        <div class="container-fluid" matLine>
          <div class="row row-cols-sm-12 p-2">
            <div class="col-md-2 col-sm-2 align-self-center text-truncate">
              <span class="fa-stack fa text-center">
                <mat-icon class="far fa-stack-2x text-medium-gray" fontSet="far" fontIcon="fa-circle"></mat-icon>
                <strong class="mr-2">
                    {{ i + 1 }}
                </strong>
            </span>
              <span>{{ data.originState.value }}, {{ data.originCity.value | titlecase }}</span>
            </div>
            <div class="col-md-2 col-sm-2 align-self-center text-truncate">
              <span>{{ data.destinationState.value }}, {{ data.destinationCity.value | titlecase }}</span>
            </div>
            <div class="col-md-2 col-sm-2 align-self-center text-truncate">
              <span [matTooltip]="data.stcc.value" class="text-truncate text-wrap">{{ data.stcc.value | titlecase }}</span>
            </div>
            <div class="col-md-2 col-sm-2 align-self-center text-truncate">
              <span class="text-truncate text-wrap">{{ data.carType.value | titlecase }}</span>
            </div>
            <div class="col-md-2 col-sm-2 align-self-center text-truncate">
              <span class="text-truncate text-wrap">{{ data.carOwner.value | titlecase }}</span>
            </div>
            <div class="col-md-2 col-sm-2 align-self-center">
              <div class="d-flex flex-wrap">
                <button (click)="edit(data, i)" aria-label="Edit" class="mr-3 list-action mb-1" mat-button matTooltip="Edit">
                  <mat-icon fontIcon="fa-edit" fontSet="fas" inline></mat-icon>
                </button>
                <button (click)="clone(data)" [disabled]="searchList.length >= maxQueries" aria-label="Clone" class="mr-3 list-action mb-1"
                        mat-button matTooltip="Clone">
                  <mat-icon fontIcon="fa-copy" fontSet="fas" inline></mat-icon>
                </button>
                <button (click)="delete(i)" aria-label="Delete" mat-button matTooltip="Delete" class="list-action bg-danger-dark mb-1">
                  <mat-icon fontIcon="fa-trash-alt" fontSet="fas" inline></mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!lastItem">
          <mat-divider></mat-divider>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>
</mat-accordion>
